/**
 * Whether the settings page shows what Prest0n Everywhere's account security adds to it (design §21.1, the client
 * switch): today Settings → "Phones & email" (S1c-1b). The one lever: `REACT_APP_ACCOUNT_SECURITY`, a list of
 * workspace ids where `*` admits every resolved workspace. Off when absent; deploy.yml ships it as `*`
 * (`vars.ACCOUNT_SECURITY` narrows or, naming no workspace, turns it off).
 *
 * The server decides everything whatever this says: the identifier doors read their own lever
 * (`ops/accountSecurity.identifiers` and `identifierPhone`, canary first), and the section shows once the list door
 * answers a half this workspace may prove or the person's own numbers and addresses (which they can always see and
 * remove). Hiding the section only hides where people manage them.
 */
import { buildEnv } from '../../config/buildEnv';

export const ACCOUNT_SECURITY_ENV = 'REACT_APP_ACCOUNT_SECURITY';

export function accountSecurityShows(
  accountId: string | null | undefined,
  env: Record<string, string | undefined> = buildEnv(),
): boolean {
  const account = String(accountId ?? '').trim();
  if (!account) return false;
  const listed = String(env[ACCOUNT_SECURITY_ENV] ?? '').split(',').map((s) => s.trim());
  return listed.includes('*') || listed.includes(account);
}
